import { useI18n } from "../../lib/i18n";

/**
 * Language toggle pill: "ES | EN".
 * The label of the inactive language is highlighted/active visually so the
 * user knows what clicking it will switch to.
 */
export default function LanguageToggle({ className = "" }) {
  const { lang, setLang, t } = useI18n();
  const isEs = lang === "es";

  return (
    <button
      type="button"
      onClick={() => setLang(isEs ? "en" : "es")}
      data-testid="lang-toggle"
      aria-label={t("nav.services") /* a11y: any label works; using nav-known key */}
      title={isEs ? "Switch to English" : "Cambiar a Español"}
      className={
        "inline-flex items-center gap-1 h-9 px-3 rounded-md border border-line " +
        "text-xs font-medium tracking-wider transition-colors " +
        "hover:border-ember/60 " + className
      }
    >
      <span
        data-testid="lang-toggle-es"
        className={isEs ? "text-ember" : "text-secondary-fg"}
      >
        ES
      </span>
      <span className="text-muted-fg/60">|</span>
      <span
        data-testid="lang-toggle-en"
        className={!isEs ? "text-ember" : "text-secondary-fg"}
      >
        EN
      </span>
    </button>
  );
}
